<template>
    <div>
        <el-form ref="form" :rules="rules" :model="form" label-width="120px" v-if="order">
            <el-form-item label="Z Station" class="mb-0" prop="station">
                <el-autocomplete
                    v-model="form.station"
                    :fetch-suggestions="querySearch"
                    placeholder="Please enter the Z Station you wish to pick your coffee up from"
                    @select="autoSelect"
                    style="width: 100%; line-height: 25px !important;"
                    >
                    <template slot-scope="{ item }" style="line-height: 25px !important;">
                        <div class="value" style="line-height: 25px !important;">{{ item.value }}</div>
                        <small style="margin: 0 0 0 0; line-height: 25px !important;" class="location">Address: {{ item.location }}, {{ item.region }}</small>
                        <hr style="margin: 0 0 0 0; line-height: 25px !important;">
                    </template>
                </el-autocomplete>
                <small class="text-muted">Please enter either the address or the name of the station</small>
            </el-form-item>
            <el-form-item label="Pickup time" prop="time">
                <el-time-select
                    v-model="form.time"
                    :picker-options="{
                        start: startTime,
                        step: '00:10',
                        end: endTime,
                    }"
                    placeholder="Select time">
                </el-time-select>
            </el-form-item>
            <el-form-item label="Drink Options" prop="coffee">
                <el-select v-model="form.coffee" placeholder="Please select your drink">
                    <el-option label="Flat White" value="flat_white"></el-option>
                    <el-option label="Mochaccino" value="mochaccino"></el-option>
                    <el-option label="Hot Chocolate" value="hot_chocolate"></el-option>
                    <el-option label="Long Black" value="long_black"></el-option>
                    <el-option label="Espresso" value="espresso"></el-option>
                    <el-option label="Cappuccino" value="cappuccino"></el-option>
                    <el-option label="Latte" value="latte"></el-option>
                    <el-option label="Chai Latte" value="chai_latte"></el-option>
                    <el-option label="Tea" value="tea"></el-option>
                    <el-option label="Lemon, Ginger and Honey" value="lemon_ginger_honey"></el-option>
                    <el-option label="Fluffy" value="fluffy"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Extra notes">
                <el-input v-model="form.notes" type="textarea" placeholder="E.g. Soy milk, extra sugar..."></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="submit()">Submit</el-button>
            </el-form-item>
        </el-form>
        <div v-else>
            {{ orderText }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'order-coffee',
        props: ['ordered', 'startingValue'],
        data() {
            return {
                form: {
					station: '',
					time: '',
                    coffee: '',
                    notes: '',
                },
                currentTime: new Date(),
                orderText: '',
                rules:{
                    station: [
                        {required: true, message: 'Please input a station', trigger: 'change'}
                    ],
                    coffee: [
                        {required: true, message: 'Please pick a drink', trigger: 'blur'}
                    ],
                    time: [
                        {required: true, message: 'Please pick a time', trigger: 'change' }
                    ]
                }
            }
        },
        methods: {
            submit(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        axios.post('/app/redeemFreeCoffee/'+ this.ordered.id,{
                            'station': this.form.station,
                            'time': this.form.time,
                            'coffee': this.form.coffee,
                            'notes': this.form.notes
                            }).then(response => {
                                this.$swal({
                                        title: "Order Placed!",
                                        text: "Your order has been placed and will be ready shortly. Please tell the barista your name to pickup your coffee.",
                                        type: "success",
                                        confirmButtonText: 'Okay',
                                    }).then(result =>{
                                        window.location.reload();
                                    });
                            }).catch(error => {
                                Event.$emit('serverError');
                                this.$emit('cancelled');
                            });
                    }else{
                        return false;
                    }
                });
            },
            canOrder(){
                if(this.ordered != null && this.ordered != 'none found' && this.ordered.can_order){
                    return true;
                }
                else{
                    this.orderText = 'Hi\, you are ' + this.scansAway + ' scans away from getting your free coffee!';
                    return false;
                }
            },
            querySearch(queryString, cb){
                if(queryString == null){
                    axios.get('/app/redeemFreeCoffee/zStations')
                    .then(res => {
                        cb(res.data.data);
                    });
                }else{
                    axios.get('/app/redeemFreeCoffee/zStations?q='+queryString)
                    .then(res => {
                        cb(res.data.data);
                    });
                }
            },
            autoSelect(item){
                this.form.station = item.value;
            }
        },
        computed: {
            endTime(){
                //Calc max time they can order, get current time add 50 mins to it and return just the hh:mm
                var time = new Date(this.currentTime.setTime(this.currentTime.getTime() +  1000 * 60 * 60 + 10 * 60000 - 10 * 60000));
                return time.toTimeString().slice(0,5);
            },
            startTime(){
                //Get current time and add 10 mins so admin has time to order, and convert to hh:mm
                var time = new Date(this.currentTime.setTime(this.currentTime.getTime() +  10 * 60000));
                return  time.toTimeString().slice(0, 5);
            },
            order(){
                return this.canOrder();
            },
            scansAway(){
                if(this.ordered.scans_count){
                    return (this.startingValue - this.ordered.scans_count);
                }else{
                    return this.startingValue;
                }
            }
        },
        }
</script>
<style scoped>
 >>> .el-autocomplete-suggestion li{
    line-height: 25px !important;
}

</style>